export const LiveStreamActions = {
  JoinLiveStream: "livestream_join",
  LeaveLiveStream: "livestream_leave",
  SendMessage: "message",
  ReceiveMessage: "receive_message",
  LiveStreamUpdateSessionEndTime: "livestream_update_session_end_time",
};
